(function(){
  const MEMBER_PROXY_PATH='/apps/retrocade-member';

  function formatPoints(value){return Number(value||0).toLocaleString();}

  function fulfillmentLabel(value){
    if(value==='in_store')return 'In-store redemption';
    if(value==='ship')return 'Shipping available';
    if(value==='automatic')return 'Automatic fulfillment';
    return 'Reward fulfillment';
  }

  function rewardTypeLabel(value){
    if(value==='arcade_tokens')return 'Arcade reward';
    if(value==='physical_merch')return 'Merchandise';
    if(value==='event_entry')return 'Event reward';
    if(value==='discount')return 'Discount';
    return 'Retrocade reward';
  }

  function make(tag,className,text){
    const node=document.createElement(tag);
    if(className)node.className=className;
    if(text!=null)node.textContent=text;
    return node;
  }

  function renderRewards(root,shop,balance,authenticated){
    const grid=root.querySelector('[data-reward-grid]');
    if(!grid)return;
    grid.replaceChildren();

    const items=Array.isArray(shop?.items)?shop.items:[];
    if(!items.length){
      grid.append(make('div','redeem-shop__empty','Rewards are being stocked. Check back soon.'));
      return;
    }

    items.forEach((item)=>{
      const card=make('article',`redeem-reward${item.featured?' is-featured':''}`);
      card.dataset.rewardId=String(item.id||'');

      card.append(make('div','redeem-reward__badge',item.badge||rewardTypeLabel(item.rewardType)));
      card.append(make('h2','redeem-reward__name',item.name||'Retrocade Reward'));
      card.append(make('p','redeem-reward__copy',item.description||''));
      card.append(make('div','redeem-reward__cost',`${formatPoints(item.pointCost)} POINTS`));

      let meta=fulfillmentLabel(item.fulfillmentType);
      if(authenticated&&Number(item.pointCost)>balance){
        meta+=` · ${formatPoints(Number(item.pointCost)-balance)} more points needed`;
      }
      card.append(make('div','redeem-reward__meta',meta));

      const button=make('button','btn btn-ghost redeem-reward__button',shop?.redemptionEnabled?'Redeem':'Coming Soon');
      button.type='button';
      button.disabled=true;
      button.setAttribute('aria-disabled','true');
      card.append(button);
      grid.append(card);
    });
  }

  async function loadShop(root){
    if(root.dataset.redeemShopReady==='true')return;
    root.dataset.redeemShopReady='true';

    const memberName=root.querySelector('[data-redeem-member-name]');
    const balanceValue=root.querySelector('[data-redeem-balance]');
    const memberCopy=root.querySelector('[data-redeem-member-copy]');
    const login=root.querySelector('[data-redeem-login]');
    const status=root.querySelector('[data-redeem-status-copy]');
    const grid=root.querySelector('[data-reward-grid]');

    try{
      const response=await fetch(MEMBER_PROXY_PATH,{method:'GET',credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
      const payload=await response.json().catch(()=>null);
      if(!response.ok||!payload||payload.ok!==true||payload.verified!==true){
        throw new Error(payload?.error||'Could not load the Redeem Shop right now.');
      }

      const authenticated=payload.authenticated===true&&payload.memberType==='retrocade_member';
      const balance=authenticated?Number(payload.rewards?.balance||0):0;
      const daily=authenticated?Number(payload.rewards?.dailyEarned||0):0;
      const dailyCap=authenticated?Number(payload.rewards?.dailyEarnCap||500):500;
      const shop=payload.redeemShop||{};

      if(authenticated){
        if(memberName)memberName.textContent=payload.playerAlias||'RETROCADE MEMBER';
        if(balanceValue)balanceValue.textContent=formatPoints(balance);
        if(memberCopy)memberCopy.textContent=`Earn 10 Reward Points per active minute, plus 25 for a successful run. You’ve earned ${formatPoints(daily)} of today’s ${formatPoints(dailyCap)}-point maximum.`;
        if(login)login.hidden=true;
      }else{
        if(memberName)memberName.textContent='GUEST PLAYER';
        if(balanceValue)balanceValue.textContent='—';
        if(memberCopy)memberCopy.textContent='Sign in as a Retrocade Member before launching a game to earn Reward Points. Game score is for the leaderboard; Reward Points are what you spend here.';
        if(login)login.hidden=false;
      }

      if(status){
        status.textContent=shop.redemptionEnabled
          ? 'Redemption is open.'
          : 'Earning is live · redemption is still in preview mode and point prices are starter values.';
      }

      renderRewards(root,shop,balance,authenticated);
    }catch(error){
      if(grid){
        grid.replaceChildren();
        grid.append(make('div','redeem-shop__error',error.message||'Could not load the Redeem Shop right now.'));
      }
      if(status)status.textContent='Redeem Shop temporarily unavailable.';
    }
  }

  function init(scope){
    const roots=(scope.matches&&scope.matches('[data-redeem-shop]'))?[scope]:[...scope.querySelectorAll('[data-redeem-shop]')];
    roots.forEach(loadShop);
  }

  document.addEventListener('DOMContentLoaded',()=>init(document));
  document.addEventListener('shopify:section:load',(event)=>init(event.target));
})();
